import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftModal from "components/SoftModal";
import SoftTypography from "components/SoftTypography";
import { useAppServices, useUploadImage } from "hook/services";
import React, { useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { useAgencyInfo } from "context/agency";
import Multiselect from "./components/Multiselect";
// import { Slider } from '@mui/material'
import Slider from "@mui/material/Slider";
import MultistepFormWizard from "./MultistepFormWizard";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 500,
  bgcolor: "background.paper",
  border: "2px  #000",
  boxShadow: 24,
  p: 4,
};

function CreateProduct({ open, onClose, product, prices, handleRefresh, data }) {
  return (
    <SoftBox>
      {open && (
        <div className="modal-zz-confirm">
          <div
            className="scrollable-modal-content bg-white  rounded"
            style={{ position: "relative" }}
          >
            <h2 className="text-black text-left font-14"> Add Plan</h2>
            <span className="crossison" onClick={onClose}>
              X
            </span>
            <MultistepFormWizard onClose={onClose} handleRefresh={handleRefresh} data={data} />
          </div>
        </div>
      )}
    </SoftBox>
  );
}

export default CreateProduct;
